"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var activityRouter = {
  path: '/activity',
  component: _layout.default,
  redirect: '/activity/couponExpand',
  name: '活动管理',
  alwaysShow: true,
  meta: {
    title: '活动管理',
    icon: 'el-icon-s-shop'
  },
  children: [{
    path: 'couponExpand',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/couponExpand/couponExpand.vue'));
      });
    },
    name: '券膨胀活动',
    meta: {
      title: '券膨胀活动',
      icon: ''
    }
  }, {
    path: 'scanCouponCode',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/scanCouponCode/scanCouponCode.vue'));
      });
    },
    name: '券包扫码兑换',
    meta: {
      title: '券包扫码兑换',
      icon: ''
    }
  }, {
    path: 'thirdSam',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/thirdSam/thirdSam.vue'));
      });
    },
    name: '外部对接',
    meta: {
      title: '外部对接',
      icon: ''
    }
  }, {
    path: 'redBook',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/redBook/redBook.vue'));
      });
    },
    name: '小红书',
    meta: {
      title: '小红书',
      icon: ''
    }
  }, {
    path: 'customerCoupone',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/customerCoupone/customerCoupone'));
      });
    },
    name: '客诉券',
    meta: {
      title: '客诉券',
      icon: ''
    }
  }, {
    path: 'red_packet',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/red_packet/RedPacketIndex.vue'));
      });
    },
    name: 'RedPacket',
    meta: {
      title: '新年红包',
      icon: ''
    }
  }, {
    path: 'Lottery',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/Lottery/LotteryIndex.vue'));
      });
    },
    name: 'Lottery',
    meta: {
      title: '抽奖活动',
      icon: ''
    }
  }, {
    path: 'BonusSend',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/BonusSend/BonusSendIndex.vue'));
      });
    },
    name: 'BonusSend',
    meta: {
      title: '优惠券发放',
      icon: ''
    }
  }, {
    path: 'PrivateArea',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/PrivateArea/PrivateAreaIndex.vue'));
      });
    },
    name: 'PrivateArea',
    meta: {
      title: '私域领券',
      icon: ''
    }
  }, {
    path: 'ConsumeCoupon',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/ConsumeCoupon/ConsumeCouponIndex.vue'));
      });
    },
    name: 'ConsumeCoupon',
    meta: {
      title: '消费领券',
      icon: ''
    }
  }, {
    path: 'couponPackage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/couponPackage/CouponPackageIndex.vue'));
      });
    },
    name: 'CouponPackage',
    meta: {
      title: '券包',
      icon: ''
    }
  }, {
    path: 'secKill',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/secKill/SecKillIndex.vue'));
      });
    },
    name: 'SecKill',
    meta: {
      title: '秒杀活动',
      icon: ''
    }
  }, {
    path: 'groupBuy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/groupBuy/GroupBuyIndex.vue'));
      });
    },
    name: 'GroupBuy',
    meta: {
      title: '拼团活动',
      icon: ''
    }
  }, {
    path: 'cipher',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/cipher/CipherIndex.vue'));
      });
    },
    name: 'Cipher',
    meta: {
      title: '口令活动',
      icon: ''
    }
  }, {
    path: 'enroll',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/enroll/EnrollIndex.vue'));
      });
    },
    name: 'Enroll',
    meta: {
      title: '报名活动',
      icon: ''
    }
  }, {
    path: 'memberDay',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/memberDay/MemberDayIndex.vue'));
      });
    },
    name: 'MemberDay',
    meta: {
      title: '会员日活动',
      icon: ''
    }
  }, {
    path: 'tieTuNumber',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/tieTuNumber/tieTuNumber.vue'));
      });
    },
    name: '贴图号',
    meta: {
      title: '贴图号',
      icon: ''
    }
  }, {
    path: 'fission',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/activity/fission/FissionIndex.vue'));
      });
    },
    name: 'Fission',
    meta: {
      title: '裂变活动',
      icon: ''
    }
  }]
};
var _default = exports.default = activityRouter;